__turbopack_context__.v({
  "actions": "AddInsoleModel-module__Jz7yXq__actions",
  "container": "AddInsoleModel-module__Jz7yXq__container",
  "row": "AddInsoleModel-module__Jz7yXq__row",
});
